import React from 'react';

export const Content = ({ children, title, onPrevClick = null, footer = null }) => {
    return (
        <div className="modal-content checkout-modal-wizard">
            <div className="modal-header">
                <div className="wizard-header">
                    {!!onPrevClick && (
                        <button type="button" className="prev-button" onClick={onPrevClick}>
                            <i className="fas fa-arrow-left"></i>
                        </button>
                    )}
                    <h5 className="modal-title font-weight-bold">{title}</h5>
                </div>
            </div>
            <div className="modal-body">
                {children}
            </div>
            {!!footer && (
                <div className="modal-footer">
                    {footer}
                    {/*<button type="button" className="btn btn-dlg-primary px-4" onClick={onClose}>OK</button>*/}
                </div>
            )}
        </div>
    )
};